export const hero_Summer = {
   title: 'Sommarerbjudanden från Kia.',
  image:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/laddbar-frihet/rangebild_hoga_kusten_1920x671px.jpg',
  mobileImage:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/laddbar-frihet/rangebild_hoga_kusten_1024x768px.jpg',
   position:'bottom',  
} as const;


export const heading = 'Sommarerbjudanden från Kia.';
export const lead =
  'Lagom till värme och ledighet höjer vi temperaturen på våra erbjudanden. Just nu har vi kampanjer på flera populära elbilar och laddhybrider. Välkommen in och upptäck den laddbara friheten med Kia.';

export const link_company  = {
  text: 'Företagserbjudanden',
  textSize: '16px',
  url: 'https://www.kia.com/se/kopa/kampanjer/elbilserbjudanden/',
  className: 'mt-6 ',
  openInNewTab: false,
};

export const link_private = {
  text: 'Privaterbjudanden',
  textSize: '16px',
  url: 'https://www.kia.com/se/kopa/erbjudanden/',
  className: 'mt-6',
  openInNewTab: false,
};
